import { useEffect, useState } from 'react';
import BonusCard from '../DealerBonus/BonusCard';
import CommonPopup from '../../components/popup/CommonPopup';

const ViewBonusPopup = (props) => {
  const { allAgent, name, icon, interest, startDate, endDate } =
    props?.bonusData || {};

  const initialFilterBonus = props?.bonusData?.allAgent || [];

  const [filterBonus, setFilterBonus] = useState(initialFilterBonus);

  // This useEffect sets the initial filterBonus when allAgent data is available
  useEffect(() => {
    // Check if props.bonusData.allAgent has changed before updating the state
    if (props?.bonusData?.allAgent) {
      setFilterBonus(props.bonusData.allAgent);
    }
  }, [props?.bonusData?.allAgent]);

  return (
    <CommonPopup
      size='xlg'
      isOpen={props?.bonusPopUp}
      onClose={() => props.closeBonusPop()}
      title={`Bonus (${allAgent ? allAgent.length : 0})`}
    >
      <div>
        <div>
          <div className='relative'>
            <div>
              {/* <div className="mt-[15px]">
                        <Input
                            prefix={<img src="/images/search.svg" alt="search" className="mr-[5px]" />}
                            placeholder="Search"
                            className="loan_com_search w-full isBorder py-[8px]"
                        />
                    </div> */}
              <div className='flex items-center flex-wrap gap-[15px_10px] justify-between pb-[20px] sticky top-[-1px] bg-white left-0 z-[10]'>
                <div className='flex items-center'>
                  <div className='mr-[12px]'>
                    <img
                      src={`https://api.ohhto.com/${icon}`}
                      alt='bank logo'
                      className='w-[47px] h-[47px] object-contain bg-white rounded-[4px]'
                    />
                  </div>
                  <div>
                    <h3 className='text-[#0D062D] font-[700]'>{name}</h3>
                    <p className='text-[12px] text-[#787486] flex items-center'>
                      <img
                        src='/images/fi_calendar.svg'
                        alt='calendar'
                        className='mr-[7px]'
                      />
                      Available from:{' '}
                      <strong className='ml-[5px] font-[600] text-[#0F0F0F]'>
                        {startDate} <span className='mx-[4px]'>to</span>{' '}
                        {endDate ? endDate : 'Further Notice'}
                      </strong>
                    </p>
                  </div>
                </div>
                <div>
                  <span className='inline-block text-[#0D062D] ml-[5px] font-[800] text-[30px]'>
                    {interest}%
                  </span>
                </div>
              </div>
              {filterBonus &&
                filterBonus.map((item, idx) => {
                  return (
                    <div
                      className='rounded-[8px] flex flex-col gap-[15px] py-[15px] bg-white relative'
                      key={idx}
                    >
                      {item.agentbonuses.map((bonus, idx) => {
                        return <BonusCard key={idx} bonus={bonus.bonusinfo} />;
                      })}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </CommonPopup>
  );
};

export default ViewBonusPopup;
